import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRefresh,
  faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { Template } from "devextreme-react";
import { assetService } from "../../../apis/apiServices/Asset";
import { Icon } from "@iconify/react/dist/iconify.js";
import { reportService } from "../../../apis/apiServices/Report";
import { Loader } from "../../Shared/PageLoader";

export default function ReportAssetMateiralMovementOrderComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "Loading Report...",
  });
  const [assetMovementRequest, setAssetMovementRequestList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Material Movement Order";
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getMaterialMovementOrderRequestLst(0, user?.userId);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getMaterialMovementOrderRequestLst = async (
    materialOrderId,
    userId
  ) => {
    try {
      // refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetMaterialMovementOrderReport(
        materialOrderId,
        userId
      );
      var data = response.data ?? [];
      setAssetMovementRequestList(data);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={assetMovementRequest}
              ref={refDataGrid}
              keyExpr="requestMovementId"
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  // {
                  //   location: "before",
                  //   template: "toolbarAddTemplate",
                  // },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                  //   {
                  //     location: "after",
                  //     widget: "dxButton",
                  //     options: {
                  //       icon: "refresh",
                  //       onClick: async () => {
                  //         await getMovementRequestLst();
                  //       },
                  //     },
                  //   }
                );
              }}
            >
              <Column
                dataField="requestMovementId"
                width={30}
                caption={""}
                allowExporting={false}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                cellRender={(data) => {
                  const rowData = data?.data;
                  const idPrefix = `icon-${rowData?.requestMovementId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/material-movement-order-preview", {
                                    state: {
                                      requestMovementId:
                                        data?.data?.requestMovementId,
                                      materialMovementOrderIndentNo:
                                        data?.data
                                          ?.materialMovementOrderIndentNo,
                                      sourceUrl: "ReportMaterialMovementOrder",
                                      isReport: true,
                                    },
                                  })
                                }
                              />
                            </span>
                          </>
                        )}
                      </div>
                    </>
                  );
                }}
              ></Column>
              <Column
                dataField="materialMovementOrderIndentNo"
                caption="Movement No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetRequestNo"
                caption="Asset Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetDescriptions"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetStatusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.statusId === AssetSubStatus.AssetMovementInDraftMode
                  )
                    color = "#494545ff";
                  else if (
                    e.data?.statusId === AssetSubStatus.AssetMovementApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMovementSendforApproval
                  )
                    color = "#FF9800";
                  return (
                    <div>
                      <span style={{ color }}>{e.data?.assetStatusName}</span>
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.toName}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="requestedDate"
                caption="Movement Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format="dd-MMM-yyyy"
              />
              <Column
                dataField="assetMaterialRequestNo"
                caption="Asset Material Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                dataField="toProjectName"
                caption="Project"
                allowSearch={true}
                allowSorting={true}
                //alignment={"center"}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.toProjectName) {
                    return (
                      <>
                        <span>{data?.data?.toProjectName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toProjectName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              /> */}
              <Column
                dataField="toProjectName"
                caption="To Project"
                allowSearch={true}
                allowSorting={true}
                //alignment={"center"}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.toProjectName) {
                    return (
                      <>
                        <span>{data?.data?.toProjectName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toProjectName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              {/* <Column
                dataField="assetDescriptions"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowSorting={true}
                //alignment={"center"}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.fromName) {
                    return (
                      <>
                        <span>{data?.data?.fromName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.fromDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowSorting={true}
                //alignment={"center"}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.toName) {
                    return (
                      <>
                        <span>{data?.data?.toName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add Movement Request"
                        className="btn btn-primary btn-sm mr-1"
                        onClick={(e) => {
                          e.preventDefault();
                          try {
                            navigate("/AddAssetRequest");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <span title="Add Movement Request">
                          <i className="fas fa-plus"></i>
                          &nbsp;&nbsp;Add
                        </span>
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getMaterialMovementOrderRequestLst(
                              0,
                              user?.userId
                            );
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Report Material Order" />
            </DataGrid>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
